import { LoadState, getOptionsLoadState } from "../store/store";

export function isOptionsLoaded(): boolean {
    return getOptionsLoadState().loadState === LoadState.OptionsLoaded;
}
